<template>
  <div class="online-cv-wrapper" :style="iosOrAndroidStyle">
    <!-- <w-nav-bar @mobileLeftBtn="routerBack" v-show="iosOrAndroidShow" nav_title="手机修改"/> -->
		<div class="icon-back" v-show="iosOrAndroidShow">
			<i class="iconfont iconx" @click="routerBack"></i>
		</div>
    <div class="online-header">
      <p class="headline title">手机号绑定</p>
    </div>
		<div class="message">绑定手机号可用验证码快速登录</div>
    <div class="phone-number-wrapper">
      <div class="phone-number flex">
        <span class="number">86</span>
        <input v-model="phone" type="text" placeholder="输入手机号">
      </div>
      <div class="verify-code flex">
        <input type="text" v-model="verifyCode" placeholder="输入验证码">
        <span class="verify-btn" :class="{'sending-code': sending}" @click="sendVerifyCode">{{ verifyText }}</span>
      </div>
    </div>
    <div class="online-footer footer">
      <button class="theme-button flex-center footer-button" :class="{'disable-button': disableState}"
              @click="savePhone">保存
      </button>
    </div>
  </div>
</template>

<script>
	import WNavBar from '@/components/global/w-navbar'
	import { mapActions, mapState } from 'vuex'
	import { componentsMixin } from '@/assets/js/mixin/components'
	import { verifyRequired, updateJWT } from '@/assets/js/utils'

	import Cookies from 'js-cookie'
	import { envMixin, eventMixin } from '@/assets/js/mixin/global'
  import { userMixin } from '@/assets/js/mixin/user'
	//获取jwt里边的参数
	import { getTUser } from '@/utils/utils'



	export default {
		name: 'phone-info',
		mixins: [ componentsMixin, eventMixin, envMixin, userMixin ],
		data () {
			return {
				sending: false,
				second: 60,
				phone: this.$route.query.phone || '',
				verifyCode: ''
			}
		},
		async mounted () {
			await this.iosBridgeGet()
      // 参数有手机号：修改绑定
      // 参数没有手机号：绑定手机号（请求接口拿到简历中的手机号自动填充）
      if (!this.$route.query.phone) {
        try {
          let res = await this.$api.auth.getUserCvPhone(this.cvAccountToken)
          if (res.code === 1000) {
            this.phone = res.data.phone
          } else {
            // this.showToast(res.message)
          }
        } catch (e) {
          console.error(e)
        }
      }
			// this._initPhoneNumber()
		},
		computed: {
			...mapState('cv', ['cv', 'onlineCvBasic']),
			verifyText () {
				return this.sending ? `${ this.second } 秒后重发` : '获取验证码'
			},
      cvAccountToken () {
	      let _t = Cookies.get('_t')
	      let tokenPayload = JSON.parse(window.atob(_t.split('.')[1]))
	      return tokenPayload.User.c_t
      },
			requiredField () {
				return [
					{ val: this.phone, message: '请填写手机号' },
					{ val: this.verifyCode, message: '请填写验证码' }
				]
			},
			disableState () {
				return verifyRequired(this.requiredField)
			}
		},
		watch: {},
		components: {
			WNavBar
		},
		methods: {
			async sendVerifyCode () {
			  console.log(this.sending,"====>sending")
				if (!this.sending) {
					if (!/^1[3456789]\d{9}$/.test(this.phone)) {
						this.showToast('请输入正确的手机号')
						return
					}
					let isSend = await this._sendCode()
					this.sending = true
					if (!isSend) {
						this.sending = false;
						return false;
					}
					let timer = setInterval(() => {
						this.second -= 1
						if (this.second === 0) {
							clearInterval(timer)
							this.sending = false
							this.second = 60
						}
					}, 1000)
				}
			},
			async _sendCode () {
        // let res = await this.$api.user.getValidateCodeNew({ phone_number: this.phone, way: 'phone', confirm: 'YES' }, this.cvAccountToken)
        let res = await this.$api.auth.getValidateCodeNew({ phone_number: this.phone, premise: 'cv_account_unregistered', new_code: true })
				if (res.code === 1000) {
					this.showToast('发送成功')
					return true;
				} else if (res.code === 200301) {
				  this.showToast(res.message)
        } else {
          if (this.isWxMini) {
            this.showToast(`手机号已注册，如需注销请\n联系在线客服`)
          } else {
            this.$createDialog({
              type: 'confirm',
              title: '该手机号已注册',
              content: '如仍需绑定请联系在线客服',
              confirmBtn: {
                text: '联系客服',
                active: true,
                disabled: false,
                href: 'javascript:;'
              },
              cancelBtn: {
                text: '取消',
                active: false,
                disabled: false,
                href: 'javascript:;'
              },
              onConfirm: async () => {
                try {
                  let res = await this.$api.user.getUdeskOnlineUrl()
                  if (res.code !== 1000) {
                    this.showToast('网络出错')
                    return false
                  }
                  window.location.href = res.data.udesk_online_url
                } catch(e) {
                  console.error(e)
                }
              },
              onCancel: async () => {

              }
            }).show()
          }
					return false;
				}
			},
			async savePhone () {
				if (verifyRequired(this.requiredField)) {
					this.showToast(verifyRequired(this.requiredField), 2000)
          return
				}
				// let payload = {
				// 	phone: this.phone,
        //   phone_token: this.verifyCode
        // }
				// let res = await this.$api.user.updateInfo(payload, this.cvAccountToken)
				// if (res.status === 1) {
				// 	this.showToast('保存成功');
				// 	setTimeout(() => {
				// 		this.routerBack();
				// 	}, 1500);
				// }
				// else {
				// 	this.showToast(res.message);
				// }

        let payload = {
          operation_type: 'bind_phone',
          phone_number: this.phone,
          phone_code: this.verifyCode
        }
        let res = await this.$api.auth.updatePhone(getTUser().t, payload)
        if (res.code === 1000) {
          this.showToast('保存成功');
          if (res.data && res.data.jwt) {
            updateJWT({
              jwt: res.data.jwt,
              jwt_timestamp: res.data.jwt_timestamp
            })
          }
          setTimeout(() => {
            this.routerBack();
          }, 1500);
        }
        else {
          this.showToast(res.message);
        }
			},
      _initPhoneNumber () {
				this.phone = this.cv.profile.phone
      },
			routerBack () {
				this.$router.back()
			}
		}
	}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/global/mixin';
  @import '@/assets/scss/global/variable';
  @import '@/assets/scss/cv/online-cv';
	.online-cv-wrapper {
		padding: 0;
	}
	.icon-back {
		padding: 0 24px;
		margin-top: 16px;
		.iconfont {
			font-size: 18px;
			font-weight: 700;
		}
	}
	.message {
		font-size: 14px;
		color: #9C9C9C;
		padding: 0 24px;
	}
  .phone-number-wrapper {
    padding: 0 24px;
		margin-top: 40px;
    .phone-number, .verify-code {
      padding: 18px 0;
      border-bottom: 1px solid #EBEBEB;
      align-items: center;
    }
    .phone-number {
      align-items: center;
      margin-top: 14px;
      span {
        color: $color-title;
        &::after {
          content: '|';
          margin: 0 16px;
          color: #D8D8D8;
        }
        &::before {
          display: inline-block;
          content: '+';
          color: $color-title;
          margin-bottom: 2px;
        }
      }
    }
    .verify-btn {
      color: #4183FF;
      font-size: $font-size-medium-x;
    }
    .sending-code {
      color: rgba($color: #4183FF, $alpha: 0.6);
    }
    input {
      flex: 1;
      border: none;
      font-size: $font-size-medium-x;
      padding: 0;
      &::placeholder {
        color: #DBDBDB;
      }
    }
  }
	.online-footer {
		position: relative;
		margin-top: 8px;
	}
</style>
